import actions from './actions';

export default {
  getSubscriptions: actions.getSubscriptions,
  subscribe: actions.subscribe,
  updateSubscription: actions.updateSubscription,
};
